export type ModelId = 'test-cube';

export type ModelTier = 'desktop-only' | 'all';

export type LoopMode = 'once' | 'repeat' | 'pingpong';

export interface ModelEntry {
  readonly id: ModelId;
  readonly path: string;
  readonly defaults?: {
    readonly position?: readonly [number, number, number];
    readonly rotation?: readonly [number, number, number];
    readonly scale?: number | readonly [number, number, number];
  };
  readonly animation?: {
    readonly clipName?: string;
    readonly loop?: LoopMode;
    readonly autoplay?: boolean;
  };
  readonly tier?: ModelTier;
  readonly notes?: string;
}

export const MODELS: Readonly<Record<ModelId, ModelEntry>> = {
  'test-cube': {
    id: 'test-cube',
    path: '/models/test-cube/model.glb',
    defaults: {
      position: [0, 0.5, 0],
      rotation: [0, 0, 0],
      scale: 0.5,
    },
    animation: {
      autoplay: true,
      loop: 'repeat',
    },
    tier: 'all',
    notes: 'Khronos BoxAnimated.glb (CC-BY). End-to-end loader smoke test.',
  },
};

export function getModel(id: ModelId): ModelEntry {
  return MODELS[id];
}
